const cube = "customers_with_availability_view";

export const cubeAdminCustomersWithAvailabilityRegionDimension = `${cube}.region`;

export const cubeAdminCustomersWithAvailabilityName = `${cube}.name`;

export const cubeAdminCustomersWithAvailabilityStatus = `${cube}.status`;

export const cubeAdminCustomersWithAvailabilityTotalMeasure = `${cube}.customer_count`;

export const cubeAdminCustomersWithAvailabilityWithAvailMeasure = `${cube}.customers_with_availability`;
